import { render, staticRenderFns } from "./DiscernmentGender.vue?vue&type=template&id=0d17fae5&scoped=true"
import script from "./DiscernmentGender.vue?vue&type=script&lang=js"
export * from "./DiscernmentGender.vue?vue&type=script&lang=js"
import style0 from "./DiscernmentGender.vue?vue&type=style&index=0&id=0d17fae5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d17fae5",
  null
  
)

export default component.exports